import { ref } from 'vue';

export default function useDialog() {
    const show = ref(null);

    const open = () => (show.value = true);
    const close = () => (show.value = false);

    return {
        show,
        open,
        close
    };
}
